export const DEFAULT_EDITOR_OPTIONS = {
    blocks: {
        audio: true,
        blockquote: true,
        bulletListItem: true,
        checkListItem: true,
        codeblock: true,
        divider: true,
        embed: true,
        heading: true,
        image: true,
        lottie: true,
        numberedListItem: true,
        toc: true,
        video: true,
    },
    components: {
        emojiPicker: true,
        formattingToolbar: {
            background: '#F9FAFB',
            displayedExternally: false,
            embedded: false,
            hideDividers: false,
            showAlignmentButtons: true,
            showBlockTypeSelect: true,
            showEmojiButton: false,
            showListButtons: false,
        },
        sideMenu: true,
        slashMenu: true,
    },
    inlineContent: {
        link: true,
        mention: false,
    },
    textStyles: {
        bold: true,
        code: true,
        italic: true,
        strike: true,
        underline: true,
    },
    trailingBlock: true,
};
//# sourceMappingURL=constants.js.map